import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getAuthCookieInfo } from 'utils/functions/authentication';
import { fetchAddUserAddress } from 'modules/order/actions';
import AddAddressComponent from 'modules/order/components/AddAddressComponent';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const AddAddressContainer = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const { loginInfo } = useSelector(state => ({
    loginInfo: state.accountManagement.loginInfo,
  }));

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [formFieldsValues, setFormFieldsValues] = useState({
    street: '',
    building: '',
    flat: '',
    landmark: '',
    label: '',
  });
  const [formFieldsValidation, setFormFieldsValidation] = useState({
    street: true,
    building: true,
    flat: true,
    landmark: true,
    label: true,
  });
  const [selectedLocation, setSelectedLocation] = useState({
    lat: 30.0445937,
    lng: 31.235577,
  });
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  const addUserAddressSuccessCallback = () => {
    navigate('/bulkOrder');
  };
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleTextInputFieldChange = (fieldName, fieldEvent) => {
    const { value } = fieldEvent.target;

    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      fieldsObj[fieldName] = value;

      return fieldsObj;
    });
  };

  const handleAddressLabelFieldChange = fieldValue => {
    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      fieldsObj.label = fieldValue;

      return fieldsObj;
    });
  };

  const handleGoogleMapsLocationChange = location => {
    setSelectedLocation(location);
  };

  const handleSubmitBtnClick = () => {
    let isFormValid = true;

    if (!formFieldsValues.street || !formFieldsValues.building || !formFieldsValues.flat) {
      setFormFieldsValidation({
        street: !!formFieldsValues.street,
        building: !!formFieldsValues.building,
        flat: !!formFieldsValues.flat,
      });
      isFormValid = false;
    }

    if (isFormValid === false) return;

    setFormFieldsValidation({
      street: true,
      building: true,
      flat: true,
    });

    const { authToken } = getAuthCookieInfo();
    const body = {
      headers: {
        Authorization: authToken,
      },
      data: {
        streetName: formFieldsValues.street,
        BuildingNumber: formFieldsValues.building,
        FlatNumber: formFieldsValues.flat,
        landmark: formFieldsValues.landmark,
        label: formFieldsValues.label,
        latitude: selectedLocation.lat,
        longitude: selectedLocation.lng,
        recipientName: loginInfo.details.Name,
        recipientNumber: loginInfo.details.MobileNumber,
      },
      callbackActionSuccess: addUserAddressSuccessCallback,
    };

    dispatch(fetchAddUserAddress(body));
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <AddAddressComponent
      formFieldsValues={formFieldsValues}
      formFieldsValidation={formFieldsValidation}
      selectedLocation={selectedLocation}
      handleTextInputFieldChange={handleTextInputFieldChange}
      handleAddressLabelFieldChange={handleAddressLabelFieldChange}
      handleGoogleMapsLocationChange={handleGoogleMapsLocationChange}
      handleSubmitBtnClick={handleSubmitBtnClick}
    />
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

AddAddressContainer.propTypes = {};

AddAddressContainer.defaultProps = {};

export default AddAddressContainer;
